// src/lib/opportunity/formatDepositRuleClient.ts

import { opportunityFetch } from "./opportunityFetch.js";
import type { OpportunityFormatKey } from "../../types/opportunity.js";
import type { FormatDepositMode, FormatDepositRule } from "./formatDepositTypes.js";

export function getFormatDepositRule(filters: {
  format_key: OpportunityFormatKey;
  product_type: string;
}) {
  const q = new URLSearchParams({
    format_key: filters.format_key,
    product_type: filters.product_type,
  });
  return opportunityFetch<{ ok: true; rule: FormatDepositRule | null }>(
    `/api/opportunity/format-deposit-rule-get?${q.toString()}`,
    { method: "GET" },
  );
}

export type UpsertFormatDepositRulePayload = {
  format_key: OpportunityFormatKey;
  product_type: string;
  deposit_mode: FormatDepositMode;
  deposit_value: number;
};

export function upsertFormatDepositRule(payload: UpsertFormatDepositRulePayload) {
  return opportunityFetch<{ ok: true; rule: FormatDepositRule }>(
    "/api/opportunity/format-deposit-rule-upsert",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    },
  );
}
